import { createStore, combineReducers } from 'redux';
import literals from './reducers';

const rootReducer = combineReducers({
  literals,
});

export default createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
